import { render, staticRenderFns } from "./updateBtn.vue?vue&type=template&id=37239440&scoped=true"
import script from "./updateBtn.vue?vue&type=script&lang=js"
export * from "./updateBtn.vue?vue&type=script&lang=js"
import style0 from "./updateBtn.vue?vue&type=style&index=0&id=37239440&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37239440",
  null
  
)

export default component.exports